export default function calcDistance(
  lat1: number,
  lon1: number,
  lat2: number,
  lon2: number,
  country: string,
) {
  // generally used geo measurement function
  const imperial = ["United States", "Liberia", "Myanmar"];

  const R = 6378.137; // Radius of earth in KM
  const dLat = (lat2 * Math.PI) / 180 - (lat1 * Math.PI) / 180;
  const dLon = (lon2 * Math.PI) / 180 - (lon1 * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  let d = R * c;

  if (imperial.includes(country)) {
    const r = 0.621371;
    d *= r; // mi
  }
  return Math.round(d * 10) / 10;
}
